export var ECaptchaConstant = /*#__PURE__*/function (ECaptchaConstant) {
  ECaptchaConstant[ECaptchaConstant["DefaultCaptchaWidth"] = 148] = "DefaultCaptchaWidth";
  ECaptchaConstant[ECaptchaConstant["DefaultCaptchaHeight"] = 39] = "DefaultCaptchaHeight";
  ECaptchaConstant["RefreshButtonText"] = "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443";
  return ECaptchaConstant;
}({});